import React, { useState } from "react";
import { Link } from "react-router-dom";

const navOption = [
  { name: "Home", link: "/" },
  { name: "About Us", link: "/" },
  { name: "Course", link: "/" },
  { name: "Event", link: "/" },
  { name: "Blogs", link: "/" },
  { name: "Career", link: "/" },
];

function Navbar() {
  const [dropdown, setDropdown] = useState(false);
  function handleDropdown() {
    setDropdown(!dropdown);
  }

  return (
    <>
      {/* <div className="fixed z-50 top-0 bg-[#FFFFFF] w-full md:px-[50px] px-[20px] md:py-[21px] py-[10px] flex items-center justify-between"> */}
      <div className="main-nav">
      
        {/* <div
          className="overlay"
          onClick={handleDropdown}
          style={dropdown ? { right: 0 } : { right: "100%" }}
        ></div> */}

          <Link to="/">
            <img src="/assets/new logo.png" className="h-[70px]" alt="" />
          </Link>
        {/* <div>
          <Link to="/">
            <img src="/assets/logo.png" className="h-[58px]" alt="" />
          </Link>
        </div>
        <div
          style={{ zIndex: 100, transition: "ease 0.5s" }}
          className={`md:relative fixed md:w-auto w-[250px] md:bg-transparent md:px-0 px-[30px] md:py-0 py-[30px] bg-[#FFFFFF] top-0 bottom-0 ${
            dropdown ? "right-0" : "sm:right-0 right-[-250px]"
          }`}
        >
          <ul className={`flex md:flex-row flex-col md:gap-[34px] gap-[20px]`}>
            {navOption.map((e, i) => {
              return (
                <div key={i}>
                  <li>
                    <Link
                      to={e.link}
                      className="font-[400] text-[18px] leading-[27px] text-[#00725d]"
                    >
                      {e?.name}
                    </Link>
                  </li>
                </div>
              );
            })}
          </ul>
          <div className="md:hidden flex md:flex-row flex-col md:justify-center justify-start gap-[10px] pt-[30px]">
            <button className="relative px-[15px]">
              <img src="/assets/cart.svg" alt="" />
              <p className="absolute top-[-5px] md:right-[-2px] right-[135px] bg-[#00725d] rounded-full px-[6px] py-[2px] font-[300] text-[11px] leading-[18px] text-[#FFFFFF]">
                0
              </p>
            </button>
            <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#f8a340] py-[11px] px-[27px] border border-[#f8a340] rounded-[50px] md:ml-[15px] ml-0">
              get in touch
              <img
                src="/assets/right-arrow.svg"
                className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
                alt=""
              />
            </button>
          </div>
        </div>
        <div className="md:flex hidden justify-center">
          <button className="relative px-[15px]">
            <img src="/assets/cart.svg" alt="" />
            <p className="absolute top-[-5px] right-[-2px] bg-[#00725d] rounded-full px-[6px] py-[2px] font-[300] text-[11px] leading-[18px] text-[#FFFFFF]">
              0
            </p>
          </button>
          <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#f8a340] py-[11px] px-[27px] border border-[#f8a340] rounded-[50px] ml-[15px]">
            get in touch
            <img
              src="/assets/right-arrow.svg"
              className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
              alt=""
            />
          </button>
        </div>
        <div className="md:hidden block">
          <i onClick={handleDropdown} className="bi bi-list"></i>
        </div> */}
      </div>
    </>
  );
}

export default Navbar;
